// Cloudflare Turnstile Configuration
const turnstileConfig = {
  siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAACVpot5bLGfpCrCp',
}

export default turnstileConfig
